<template>
  <div class="smsx">

    <!-- ── Filter workspace ── -->
    <div class="smsx-filter">
      <div class="smsx-filter__head">
        <span class="smsx-filter__badge"><i class="fas fa-sliders-h"/></span>
        <span class="smsx-filter__title">{{ msg('Filters') }}</span>
        <span class="smsx-filter__line"/>
        <button type="button" class="smsx-icon-btn" v-b-tooltip.hover :title="msg('Reload')" @click="refresh()">
          <i class="fas fa-redo" :class="{'fa-spin': loading}"/>
        </button>
      </div>

      <div class="smsx-grid">
        <!-- Branch -->
        <div class="smsx-field">
          <label class="smsx-label"><i class="fas fa-code-branch mr-25"/>{{ msg('Branch') }}</label>
          <v-select
              v-model="filter.buid"
              :dir="isRTL ? 'rtl' : 'ltr'"
              :options="allBranches"
              class="smsx-select w-100"
              label="name"
              :reduce="(branch) => branch.id"
              :clearable="false"
          />
        </div>

        <!-- Sender -->
        <div class="smsx-field">
          <label class="smsx-label"><i class="fas fa-paper-plane mr-25"/>{{ msg('sender') }}</label>
          <b-input-group size="sm" class="smsx-group">
            <b-input-group-prepend is-text><i class="fas fa-phone"/></b-input-group-prepend>
            <b-form-input v-model="filter.from"/>
          </b-input-group>
        </div>

        <!-- Receiver -->
        <div class="smsx-field">
          <label class="smsx-label"><i class="fas fa-inbox mr-25"/>{{ msg('receiver') }}</label>
          <b-input-group size="sm" class="smsx-group">
            <b-input-group-prepend is-text><i class="fas fa-phone"/></b-input-group-prepend>
            <b-form-input v-model="filter.to"/>
          </b-input-group>
        </div>

        <!--          Status filter (kept disabled, as before)
        <div class="smsx-field">
          <label class="smsx-label">{{ msg('Status') }}</label>
          <v-select
              v-model="filter.status"
              :options="messageStatus"
              class="smsx-select w-100"
              label="text"
              :reduce="(status) => status.value"
          />
        </div>-->
      </div>
    </div>

    <!-- ── Messages panel ── -->
    <div class="smsx-panel">
      <div class="smsx-panel__head">
        <span class="smsx-panel__badge"><i class="fas fa-message"/></span>
        <span class="smsx-panel__title">{{ msg('Messages') }}</span>
        <b-badge v-if="count > 0" pill variant="light-primary" class="ml-50">{{ count }}</b-badge>
        <span class="smsx-panel__line"/>
      </div>

      <!--Table-->
      <messages-table v-bind:filter="filter" ref="messages-table" @busy="loading = $event" @count="count = $event"/>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MessagesTable from "@/components/tables/MessagesTable.vue";

export default {
  name: "messages",
  components: {MessagesTable},
  data: () => ({
    loading: false,
    count: 0,
    loadingStats: true,

    filter: {
      from: null,
      to: null,
      status: null,
      buid: null,
      pageUrl: null  // this holds next/previous cursor from API

    },
    stats: {},
  }),
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh();
      }
    },
  },
  created() {
    if (this.allBranches.length > 0 && !this.filter.buid) {
      this.filter.buid = this.allBranches[0].id;
    }
  },
  mounted() {
    this.refresh();

  },
  computed: {

    ...mapGetters('reception', ['allStatusMessages']),
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    messageStatus() {
      let $this = this;
      return this.allStatusMessages.map(status => ({
        value: status.value,
        text: $this.msg(status.text)
      }))
    },
  },

  methods: {

    refresh() {
      // guard: the deep watcher can fire before the table is mounted
      if (this.$refs['messages-table'] != null) {
        this.$refs['messages-table'].refresh();
      }
    },
  }
}
</script>


<style lang="scss" scoped>
/* ── filter workspace ── */
.smsx-filter {
  background: #fff; border: 1px solid rgba(15, 23, 42, .06); border-radius: 16px;
  padding: 14px 18px; margin-bottom: 14px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, .04);
}
.smsx-filter__head { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.smsx-filter__badge {
  width: 30px; height: 30px; border-radius: 9px; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(115, 103, 240, .14); color: #7367f0; font-size: .8rem;
}
.smsx-filter__title { font-size: .82rem; font-weight: 800; text-transform: uppercase; letter-spacing: .06em; color: #475569; }
.smsx-filter__line { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(100, 116, 139, .18), transparent); }
.smsx-icon-btn {
  width: 30px; height: 30px; border: none; border-radius: 9px; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(15, 23, 42, .05); color: #64748b; font-size: .74rem;
  transition: background .15s, color .15s;
  &:hover { background: rgba(115, 103, 240, .14); color: #7367f0; }
  &:focus { outline: none; }
}

/* filter grid */
.smsx-grid { display: grid; grid-template-columns: 1.2fr 1fr 1fr; gap: 12px 14px; align-items: end; }
@media (max-width: 992px) { .smsx-grid { grid-template-columns: 1fr 1fr; } }
@media (max-width: 640px) { .smsx-grid { grid-template-columns: 1fr; } }
.smsx-field { min-width: 0; }
.smsx-label {
  display: flex; align-items: center;
  font-size: .66rem; font-weight: 800; text-transform: uppercase; letter-spacing: .06em;
  color: #94a3b8; margin-bottom: 5px;
  i { opacity: .7; }
}
.smsx-field :deep(.form-control) { height: 34px; }
.smsx-group :deep(.input-group-text) { height: 34px; background: rgba(15, 23, 42, .03); border-color: rgba(15, 23, 42, .1); color: #94a3b8; font-size: .7rem; }
.smsx-field :deep(.vs__dropdown-toggle) { min-height: 34px; border-color: rgba(15, 23, 42, .1); }

/* ── messages panel ── */
.smsx-panel {
  background: #fff; border: 1px solid rgba(15, 23, 42, .06); border-radius: 16px;
  padding: 14px 18px 12px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, .04);
}
.smsx-panel__head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.smsx-panel__badge {
  width: 30px; height: 30px; border-radius: 9px; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(0, 165, 181, .14); color: #00a5b5; font-size: .8rem;
}
.smsx-panel__title { font-size: .82rem; font-weight: 800; text-transform: uppercase; letter-spacing: .06em; color: #475569; }
.smsx-panel__line { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(100, 116, 139, .18), transparent); }
</style>

<style lang="scss">
.dark-layout {
  .smsx-filter, .smsx-panel { background: #283046; border-color: rgba(255, 255, 255, .07); box-shadow: 0 2px 10px rgba(0, 0, 0, .2); }
  .smsx-filter__title, .smsx-panel__title { color: #d0d2d6; }
  .smsx-filter__line, .smsx-panel__line { background: linear-gradient(90deg, rgba(255, 255, 255, .12), transparent); }
  .smsx-icon-btn { background: rgba(255, 255, 255, .06); color: #94a3b8; }
  .smsx-label { color: #8a92a6; }
  .smsx-group .input-group-text { background: rgba(255, 255, 255, .04); border-color: rgba(255, 255, 255, .12); color: #8a92a6; }
}
</style>
